/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invoiceBreakdownDataSchema = z.object({
	invoiceId: z.string(),
	currency: z.string(),
	lineItems: z.array(z.object({ description: z.string(), amount: z.number() })),
	subtotal: z.number(),
	tax: z.number(),
	total: z.number(),
	amountPaid: z.number(),
	amountRemaining: z.number(),
	payments: z.array(
		z.object({
			id: z.string(),
			currency: z.string(),
			amount: z.number(),
			status: z.string(),
			paidAt: z.iso.datetime().nullable(),
			paymentMethod: z.union([z.literal('Jobilla Wallet'), z.literal('Card'), z.literal('Bank Transfer')])
				.nullable(),
			receiptNumber: z.string().nullable(),
			metadata: z.record(z.string(), z.string()),
		}),
	),
	walletBalance: z.number(),
	canPayViaWallet: z.boolean(),
})

export type InvoiceBreakdownDataSchema = z.infer<typeof invoiceBreakdownDataSchema>
